var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"app",attrs:{"id":"app"}},'div',_vm.app,false),[_c('router-view',{staticClass:"filterBlur"}),(_vm.$store.state.hasUpdateSW)?_c('Pop'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }